
export const features = {

    // Setup Features
    salesTeam: true,  // *
    users: true,  // *
    cpManagement: false,
    properties: true,   // *
    propertyInventory: true,  // *
    interestSource: true, // *
    integration: false,
    customAPI: false,
    incentives: false,
    autoMessage: false,
    marketingHub: false,  // *
    contentHub : false, 
    spinWheel: false, // *
    glPages: false, // *

    // IVR Features
    ivrCalls: false,  // *


    notification: true, 
  };
  